import { useEffect } from 'react';
const PIXEL_ID = '1688340325556911';
const SCRIPT_FLAG = 'data-meta-pixel';
type FbqFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: unknown;
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & {
  fbq?: FbqFunction;
  _fbq?: FbqFunction;
};
export function MetaPixel() {
  useEffect(() => {
    const win = window as PixelWindow;
    if (!win.fbq) {
      const fbq: FbqFunction = function (...args: unknown[]) {
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, args);
        } else {
          fbq.queue?.push(args);
        }
      };
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      win.fbq = fbq;
      if (!win._fbq) win._fbq = fbq;
    }
    if (!document.querySelector(`script[${SCRIPT_FLAG}]`)) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.setAttribute(SCRIPT_FLAG, 'true');
      const first = document.getElementsByTagName('script')[0];
      if (first && first.parentNode) {
        first.parentNode.insertBefore(script, first);
      } else {
        ;
        (document.head || document.documentElement).appendChild(script);
      }
    }
    win.fbq?.('init', PIXEL_ID);
    win.fbq?.('track', 'PageView');
  }, []);
  return <noscript data-id="element-132" data-mp="1rdudqtlyo7rn">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-133" data-mp="1rdb7ia5ob7tg" />
    </noscript>;
}